export const university = "TwinBots";
